import React, { useState, useEffect, useContext } from 'react';
import {format, parse} from "date-fns";

import * as net from "../../../lib/net";
import * as utils from "../../../assets/utils";

import Dd_Sel from "../../../lib/ui/dd_sel";
import Dt_Cal from "../../../lib/ui/dt_cal";
import Edit_Txt from "../../../lib/ui/edit_txt";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Tid from "../../../lib/ui/fr_tid";
import Td_Sel from "../../../lib/ui/td_sel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class EE_Dt extends React.Component {
  constructor(props, context) {
    super(props);

    this.dt_dt = React.createRef();
      this.dt_rtid = React.createRef();
      this.dt_vtid = React.createRef();

      this.selrowitems = [
          {fkn: 'edit', text: 'ÖPPNA'},
          {fkn: 'remove', text: 'TABORT'}
      ];

    this.store = props.store;
    //this.pms = props.store.pms;

    this.state = {};
    this.state.ynq = [];
    //this.state.vga = [];
    this.state.rta = [];
    this.state.bra = [];

      this.state.tya = [];
      this.state.tya.push({ "id": "0001", "text": "START" });
      this.state.tya.push({ "id": "0002", "text": "SLUT" });

      this.state.dta = [];
      this.state.tot = {};
      this.state.tro = {};
      this.state.tro.avd = "";
      if(this.props.store.ta.dpa[0]) this.state.tro.avd = this.props.store.ta.dpa[0].avdelning;
      this.state.tro.typ = "0001";

    this.state.datum = "";
    this.state.fdat = "";
    this.state.tdat = "";
      this.state.enr = "";

    this.state.wnds = {};
      this.state.eeo = {};
    if(props.wnds) {
        if(props.wnds.datum) this.state.datum = props.wnds.datum;
        if(props.wnds.eeo) {
            this.state.eeo = props.wnds.eeo;
            this.state.enr = props.wnds.eeo.anstnummer;
        }
    }
     //var dat = new Date(this.state.datum);
      var dat = parse( this.state.datum, "yyyyMMdd", new Date() );
      this.state.dts = format(dat, "yyyy-MM-dd");

  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      this.ee_dt();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tb_style() {
        var css = {};
        css.height = ( window.innerHeight * 0.7 ) - 265;
        css.overfow = "auto";
        return css;
    }
  val_pris(val) {
      var s = "";
      if(val == 0) s = "0.00";
      if(val) s = val.cdipris();
      return s;
  };
    change_avd(e) {
        let tro = this.state.tro;
        tro.avd = e.target.value;
        this.setState({tro: tro});
    }
    change_typ(e) {
        let tro = this.state.tro;
        tro.typ = e.target.value;
        this.setState({tro: tro});
    }
    val_save (name, value) {
        var tro = this.state.tro;
        tro[name] = value;
        this.setState({tro: tro});
    }

    wnd_close = () => {
      if(this.props.wnds.cb) {
          this.props.wnds.cb(this.props.ctx);
      }
      else this.props.ctx.setState({ wnds: {} });
	};
  dt_dat(e) {
    //alert(JSON.stringify(e));
    var dts = format(e, "yyyy-MM-dd");
    this.setState({ dts: dts });
  }
  addday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_dt.current.updateAdd();
  }
  subday(e) {
      //alert(JSON.stringify(e));
    //this.setState({ tdat: this.state.fdat });
    this.dt_dt.current.updateSub();
  }
  gst_open(row) {
    //alert(JSON.stringify(row));
    var wnds = {};
    wnds.saldogst = true;
    wnds.boknr = row.boknr;
    wnds.glopnr = row.glopnr;
    this.setState({wnds: wnds});
  }
  ee_dt() {
    var self = this;
    //var fdatum = format(this.state.fdat, "yyyy-MM-dd");
    //var tdatum = format(this.state.tdat, "yyyy-MM-dd");
    self.setState({ dta: [] });

    var prm = {};
    prm.req = "ta.ta_th.ee_tp_ft";
    prm.fdat = this.state.dts;
    prm.tdat = this.state.dts;
    prm.enr = this.state.enr;
    //alert(JSON.stringify(prm));
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        var dta = ret.rca;
        self.setState({ dta: dta });
        self.syncTb("dtsTable");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
    }
    syncTb(tb){
        if (!document.getElementById(tb)) {
            //alert("No tb");
            return;
        }
        var tbel = document.getElementById(tb);
        const thElements = tbel.getElementsByTagName('th'),
        tdElements = tbel.getElementsByTagName('td');

        for (let i = 0; i < thElements.length; i++) {
            const widerElement =
                    thElements[i].offsetWidth > tdElements[i].offsetWidth ? thElements[i] : tdElements[i],
            width = window.getComputedStyle(widerElement).width;
            thElements[i].style.width = tdElements[i].style.width = width;
        }
    }
    dt_edit(row) {
        var self = this;
        var wnds = {};
        wnds.dtedit = 1;
        wnds.fdat = this.state.fdat;
        wnds.tdat = this.state.tdat;
        wnds.dto = row;
        this.setState({wnds: wnds});
    }
    rtid_upd(row, e) {
        var self = this;

        var rtid = e;
        //alert(JSON.stringify(row));

        var prm = {};
        prm.req = "ta.ta_th.ee_tr_upd";
        prm.tpo = row;
        prm.rtid = rtid;
        //prm.enr = this.state.eeo.anstnummer;

        net.sio_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            if(ret.ok != "000") {
                return;
            }
            //self.ee_dt();
            var prm = {};
            prm.req = "ta.ta_th.ee_tp_ft";
            prm.fdat = self.state.dts;
            prm.tdat = self.state.dts;
            prm.enr = self.state.enr;
            //alert(JSON.stringify(prm));
            return net.sio_req(prm);
        })
        .then(function(ret) {
            //alert(JSON.stringify(ret));

            if(ret.ok != "000") {
                return;
            }
            var dta = ret.rca;
            self.setState({ dta: dta });
            self.syncTb("dtsTable");
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
    }
    tr_add() {
        var self = this;

        var tro = this.state.tro;
        tro.dts = this.state.dts;
        tro.enr = this.state.enr;
        //alert(JSON.stringify(tro));

        var prm = {};
        prm.req = "ta.ta_th.ee_tr_add";
        prm.tro = tro;
        //prm.enr = this.state.eeo.anstnummer;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                //self.ee_dt();
                var prm = {};
                prm.req = "ta.ta_th.ee_tp_ft";
                prm.fdat = self.state.dts;
                prm.tdat = self.state.dts;
                prm.enr = self.state.enr;
                //alert(JSON.stringify(prm));
                return net.sio_req(prm);
            })
            .then(function(ret) {
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                var dta = ret.rca;
                self.setState({ dta: dta });
                self.syncTb("dtsTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    tr_del(row) {
        var self = this;

        var prm = {};
        prm.req = "ta.ta_th.ee_tr_del";
        prm.tro = row;
        //prm.enr = this.state.eeo.anstnummer;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                //self.ee_dt();
                var prm = {};
                prm.req = "ta.ta_th.ee_tp_ft";
                prm.fdat = self.state.dts;
                prm.tdat = self.state.dts;
                prm.enr = self.state.enr;
                //alert(JSON.stringify(prm));
                return net.sio_req(prm);
            })
            .then(function(ret) {
                //alert(JSON.stringify(ret));

                if(ret.ok != "000") {
                    return;
                }
                var dta = ret.rca;
                self.setState({ dta: dta });
                self.syncTb("dtsTable");
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    sel_row_fkn(row, sel) {
        //alert(JSON.stringify(fkn));
        if(sel.fkn == "edit") {
        }
        if(sel.fkn == "remove") {
            this.tr_del(row);
        }
    }
    show_reason(row) {
        var txt = row.anledning;

        if(row.anledning == "0001") {
            txt = "START";
        }
        if(row.anledning == "0002") {
            txt = "SLUT";
        }
        return txt;
    }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Bokning";

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_70 flex-col" style={ this.dlg_style() }>
        <div className="mx_h01">
            <div>Transaktioner Datum</div>
        </div>

            <div className="divider_orange hide"></div>

            <div className="flex-row">
                <div className="flex"></div>
            <div className="flex-row">
                  <div className="dt-btn-01" onClick={() => this.subday() } ><FontAwesomeIcon icon="minus" size="1x" /></div>
                  <Dt_Cal dts={ this.state.dts } rp="1" ref={this.dt_dt} getValue={(e)=> this.dt_dat(e)} />
                   <div className="dt-btn-01" onClick={() => this.addday() } ><FontAwesomeIcon icon="plus" size="1x" /></div>
            </div>
                <div className="flex"></div>
                <button className="btn btn-hw-blue w150" onClick={() => this.ee_dt() } aria-label="System" >
                    Visa
                </button>
            </div>
             <div className="divider_green"></div>
            <div className="flex-row hide">
                <div className="px-2">Timmar : { this.val_pris( this.state.tot.krubba ) }</div>
                <div className="px-2">OB : { this.val_pris( this.state.tot.topay ) }</div>
            </div>
       <div className="mx_content flex-col flex">

        <div id="dtsTable">
          <table className="table table-bordered table-hover tb" style={{marginBottom: "0px"}}>
            <thead>
            <tr>
                <th>Datum</th>
                <th>Avd</th>
                <th>Typ</th>
                <th>RTid</th>
                <th>VTid</th>
                <th>Inslaget</th>
                <th></th>
            </tr>
            </thead>
            </table>
            <div style={ this.tb_style() }>
          <table className="table table-bordered table-hover tb">
            <tbody>
            { this.state.dta.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.dt_edit(row) }>
                <td>{ utils.toDate( row.datum ) }</td>
                <td>{ row.avdelning }</td>
                <td>{ this.show_reason(row) }</td>
                <td><Edit_Txt text={ row.rtid.cditid() } getValue={(e)=> this.rtid_upd(row, e) } /></td>
                <td>{ utils.toTid( row.vtid ) }</td>
                <td>{ row.inslaget }</td>
                <td>
                    <Td_Sel items={ this.selrowitems } factor="0.7" getValue={(e)=> this.sel_row_fkn(row, e)} />
                </td>
            </tr>
            )}
            </tbody>
        </table>
        </div>
        </div>

           <div className="divider_green"></div>
           <div className="flex-row px-2">
               <div className="flex-col">
                   <span>Avd</span>
                   <select className="form-control input-rp-01 w300" placeholder="Välj avdelning" onChange={(e) => this.change_avd(e)}>
                       { this.props.store.ta.dpa.map((row, key) =>
                           <option key={key} value={row.avdelning}>{row.avdelning} - {utils.toLang( row.namn )}</option>
                       )}
                   </select>
               </div>
               <div className="flex-col">
                   <span>Typ</span>
                   <select className="form-control input-rp-01 w250" placeholder="Definition" onChange={(e) => this.change_typ(e)}>
                       { this.state.tya.map((row, key) =>
                           <option key={key} value={row.id}>{row.text}</option>
                       )}
                   </select>
               </div>
               <div className="flex"></div>
               <Fr_Tid col label="R-Tid" tps="00:00" rp="1" ref={this.dt_rtid} text={this.state.tro.rtid} getValue={(e)=> this.val_save("rtid", e) } />
               <div className="flex-col">
                   <span>&nbsp;</span>
               <button className="btn btn-hw-red w150" onClick={() => this.tr_add() } >
                   LÄGG TILL
               </button>
               </div>
           </div>

        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            </div>
        </div>
      </div>

    </div>
	;
	return html;
  };
}

export default EE_Dt;